import { Label } from '@components/ui/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue
} from '@components/ui/select';
import { Separator } from '@components/ui/separator';
import { type DateFormatType, DateFormatUtils } from '@stratumn/studio-shared';
import moment from 'moment';

type Props = React.PropsWithChildren<{
  id: string;
  format: DateFormatType;
  onFormatChange: (format: DateFormatType) => void;
  label?: string;
}>;

const exampleDate = moment('2024-06-13');
export const DateFormatPicker = ({
  format,
  onFormatChange,
  id,
  label
}: Props) => (
  <>
    {label && <Label htmlFor={id}>{label}</Label>}
    <Select autoComplete="off" onValueChange={onFormatChange} value={format}>
      <SelectTrigger id={id}>
        <SelectValue placeholder="DD/MM/YYYY" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Classic formats</SelectLabel>
          {DateFormatUtils.ClassicFormats.map(format => (
            <SelectItem key={format} value={format}>
              {exampleDate.format(format)}
            </SelectItem>
          ))}
        </SelectGroup>

        <Separator className="my-2" />

        <SelectGroup>
          <SelectLabel>Verbose formats</SelectLabel>

          {DateFormatUtils.VerboseFormats.map(format => (
            <SelectItem key={format} value={format}>
              {exampleDate.format(format)}
            </SelectItem>
          ))}
        </SelectGroup>

        <Separator className="my-2" />

        <SelectGroup>
          <SelectLabel>Other formats</SelectLabel>
          {DateFormatUtils.OtherFormats.map(format => (
            <SelectItem key={format} value={format}>
              {exampleDate.format(format)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  </>
);
